import API from "./api";

const AuthService = {
  login: data => {
    return API.post("/login", data)
      .then(({ data }) => {
        // API.defaults.headers['Authorization'] = `Bearer ${data.token}`;
        setHeadersAndStorage(data);
        return data;
      })
      .catch(err => {
        console.log("Auth error", err);
        throw err;
      });
  },

  logout: () => {
    API.defaults.headers["Authorization"] = "";
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
  },

  userDetails: () => {
    return API.post("/userdetails", "", {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("azureToken") || ""}`,
      },
    })
      .then(({ data }) => {
        setHeadersAndStorage(data);
        // console.log(data);
        return data;
      })
      .catch(err => {
        console.log("Auth error", err);
        throw err;
      });
  },
};

const setHeadersAndStorage = ({ user, token }) => {
  API.defaults.headers["Authorization"] = `Bearer ${token}`;
  sessionStorage.setItem("user", JSON.stringify(user));
  sessionStorage.setItem("token", token);
};

export default AuthService;
